export default "__VITE_ASSET__df871076__"